import StockTakeBranchSelect from "./stockTakeBranchSelect.container";

export default StockTakeBranchSelect;
